<template>
  <div class="container pa-5">
    <reg-search></reg-search>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>
